import dayjs from 'dayjs';

export const API = {
  contactsCrew: {
    path: '/users?filters[$and][0][role][name][$eq]=Crew',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => ({
      meta: data?.meta,
      data: data?.data.map((item) => ({
        id: item?.id,
        attributes: {
          ...item,
        },
      })),
    }),
  },

  contactCrew: {
    path: '/users/{{id}}?filters[$and][0][role][name][$eq]=Crew',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (data) => {
      return { data: data };
    },
  },

  contactsYachtMember: {
    path: '/user-yacht-members',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (response) => ({
      meta: response?.meta,
      data: response?.data?.map((item) => ({
        id: item?.id,
        attributes: {
          createdAt: item?.attributes?.createdAt,
          updatedAt: item?.attributes?.updatedAt,
          crew_responsability: item?.attributes?.crew_responsability,
          is_delivery_manager_on_board:
            item?.attributes?.is_delivery_manager_on_board,
          is_main_contact: item?.attributes?.is_main_contact,
          status: item?.attributes?.status,
          start_date: item?.attributes?.start_date,
          end_date: item?.attributes?.end_date,
          name:
            item?.attributes?.id_users_permissions_user?.data?.attributes?.name,
          surname:
            item?.attributes?.id_users_permissions_user?.data?.attributes
              ?.surname,
          email:
            item?.attributes?.id_users_permissions_user?.data?.attributes?.email,
          phone_number:
            item?.attributes?.id_users_permissions_user?.data?.attributes
              ?.phone_number,
          birthdate:
            item?.attributes?.id_users_permissions_user?.data?.attributes
              ?.birthdate,
          username:
            item?.attributes?.id_users_permissions_user?.data?.attributes
              ?.username,
          yacht_name:
            item?.attributes?.id_yacht?.data?.attributes?.yacht_name,
          id_yacht: item?.attributes?.id_yacht?.data
            ? {
              id: item?.attributes?.id_yacht?.data?.id,
              ...item?.attributes?.id_yacht?.data?.attributes,
            }
            : null,
          id_users_permissions_user:
            item?.attributes?.id_users_permissions_user?.data
              ? {
                id: item?.attributes?.id_users_permissions_user?.data?.id,
                ...item?.attributes?.id_users_permissions_user?.data?.attributes,
              }
              : null,
        },
      })),
    }),
  },

  contactYachtMember: {
    path: '/user-yacht-members/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    transform: (response) => {
      const item = response?.data;

      return {
        data: item
          ? {
            id: item?.id,
            createdAt: item?.attributes?.createdAt,
            updatedAt: item?.attributes?.updatedAt,
            crew_responsability: item?.attributes?.crew_responsability,
            is_delivery_manager_on_board:
              item?.attributes?.is_delivery_manager_on_board,
            is_main_contact: item?.attributes?.is_main_contact,
            status: item?.attributes?.status,
            start_date: item?.attributes?.start_date,
            end_date: item?.attributes?.end_date,
            birthdate:
              item?.attributes?.id_users_permissions_user?.data?.attributes?.birthdate,
            id_yacht: item?.attributes?.id_yacht?.data
              ? {
                id: item?.attributes?.id_yacht?.data?.id,
                ...item?.attributes?.id_yacht?.data?.attributes,
              }
              : null,
            id_users_permissions_user:
              item?.attributes?.id_users_permissions_user?.data
                ? {
                  id: item?.attributes?.id_users_permissions_user?.data?.id,
                  ...item?.attributes?.id_users_permissions_user?.data
                    ?.attributes,
                }
                : null,
          }
          : null,
      };
    },
  },

  create: {
    path: '/user-yacht-members',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      let obj = body;

      if (body?.country_code) {
        obj = {
          ...body,
          phone_number: `${body?.country_code?.phone}-${body?.phone_number}`,
        };
      }
      delete obj.country_code;

      return {
        data: {
          ...obj,
          id_yacht: obj?.id_yacht?.id,
          crew_responsability: obj?.crew_responsability?.label,
          username: obj?.username,
          email: obj?.email,
          name: obj?.name,
          surname: obj?.surname,
          password: obj?.password,
          start_date: obj?.start_date
            ? dayjs(obj?.start_date).format('YYYY-MM-DD')
            : null,
          end_date: obj?.end_date
            ? dayjs(obj?.end_date).format('YYYY-MM-DD')
            : null,
          is_delivery_manager_on_board: obj?.is_delivery_manager_on_board,
          birthdate: obj?.birthdate
            ? dayjs(obj?.birthdate).format('YYYY-MM-DD')
            : null,
        },
      };
    },
  },

  update: {
    path: '/user-yacht-members/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      let obj = body;

      if (body?.country_code) {
        obj = {
          ...body,
          phone_number: `${body?.country_code?.phone}-${body?.phone_number}`,
        };
      }
      delete obj.country_code;
      return {
        data: {
          ...obj,
          crew_responsability: obj?.crew_responsability?.label,
          phone_number: obj?.phone_number,
          username: obj?.username,
          email: obj?.email,
          name: obj?.name,
          surname: obj?.surname,
          start_date: obj?.start_date
            ? dayjs(obj?.start_date).format('YYYY-MM-DD')
            : null,
          end_date: obj?.end_date
            ? dayjs(obj?.end_date).format('YYYY-MM-DD')
            : null,
          birthdate: obj?.birthdate
            ? dayjs(obj?.birthdate).format('YYYY-MM-DD')
            : null,
        },
      };
    },
  },

  delete: {
    path: '/user-yacht-members/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },

  crewCSV: {
    path: '/users-csv?filters[role][name][$eq]=Crew&populate[id_users_nautica][populate][id_users_nautica_departments][populate][id_department][fields][0]=name_department&populate[role]=name&populate[id_yacht_member][populate][id_yacht][fields][0][1][2]=yacht_name,commercial,feedback&populate[id_users_role]=role',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
}
